import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function AuthGuard({ children }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="page" style={{ alignItems: 'center', justifyContent: 'center' }}>
        <p className="text-muted" style={{ fontFamily: 'var(--font-heading)', fontSize: '1.4rem' }}>
          Loading...
        </p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Only redirect to onboarding if user has never uploaded a photo
  // and is not already on onboarding or confirmed pages
  const onboardingRoutes = ['/onboarding', '/confirmed'];
  if (
    profile &&
    !profile.profile_photo_url &&
    !onboardingRoutes.includes(location.pathname)
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
